"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _typography = require("../typography");

var _helpers = require("../../helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Li = _styledComponents.default.li.withConfig({
  displayName: "Li",
  componentId: "sc-11g1v69-0"
})(["position:relative;margin:0;padding:0;list-style:none;clear:left;", " & + li{margin-top:16px;}", "{color:", ";margin-bottom:4px;}", "{display:block;margin-bottom:4px;}"], function (p) {
  return p.hasIcon && "\n    margin-left: 32px;\n  ";
}, _typography.Subtitle2, (0, _helpers.color)('dark-2'), _typography.Strong);

var IconContainer = _styledComponents.default.div.withConfig({
  displayName: "IconContainer",
  componentId: "sc-11g1v69-1"
})(["position:absolute;top:1px;left:-32px;width:16px;height:16px;overflow:hidden;svg{width:16px;height:16px;}"]);

var ListItem = function ListItem(_ref) {
  var title = _ref.title,
      label = _ref.label,
      icon = _ref.icon,
      children = _ref.children;
  return _react.default.createElement(Li, {
    hasIcon: !!icon
  }, icon && _react.default.createElement(IconContainer, null, icon), title && _react.default.createElement(_typography.Strong, null, title), label && _react.default.createElement(_typography.Subtitle2, null, label), _react.default.createElement(_typography.Body, null, children));
};

var _default = ListItem;
exports.default = _default;